const Kind = {
  Primary: 'primary',
  Secondary: 'secondary',
  Ternary: 'ternary',
  Success: 'success',
  Warning: 'warning',
  Error: 'error',
};

export { Kind as default, Kind };
